import { styled } from '@mui/material';
import type { CardProps } from '@mui/material/Card';
import MuiCard from '@mui/material/Card';
import { clsx } from 'clsx';
import type { FC, ReactElement } from 'react';
import { Children } from 'react';

const StyledCard = styled(MuiCard)<CardProps>(({ theme }) => ({
  '&.mnt-card-action:hover': {
    boxShadow: theme.shadows[4],
  },
  '.MuiCard-root': {
    boxShadow: theme.shadows[0],
  },

  '.MuiCardActionArea-focusHighlight': {
    background: 'none',
  },
}));

const Card: FC<CardProps> = ({ className, ...rest }) => {
  const hasActionArea = Children.toArray(rest.children).some(
    // @ts-expect-error -- `type` is not fully typed for custom components but is safe here.
    (child) => (child as ReactElement).type.displayName === 'CardActionArea'
  );
  const classes = clsx('mnt-card', className, {
    'mnt-card-action': hasActionArea,
  });

  return <StyledCard {...rest} className={classes} />;
};
Card.displayName = 'Card';

export default Card;
export type { CardProps };
